<template>
  <div>
    <Modal title="分配孤儿单" v-model="visible" width="1200" class="my-modal top" :mask-closable="false" :footer-hide="true">
      <div class="search-box min">
        <div class="input-item">
          <span class="label">保单号 </span>
          <Input v-model="searchParams.policyNo" placeholder="请输入" clearable />
        </div>
        <div class="input-item">
          <span class="label">保险公司</span>
          <Select v-model="searchParams.companyCode" transfer placeholder="请选择保司" clearable filterable>
            <Option v-for="(item, index) in companyList" :value="item.code" :key="index">{{ item.name }}</Option>
          </Select>
        </div>
        <div class="input-item">
          <span class="label">出单人</span>
          <Select v-model="searchParams.salesmanId" transfer clearable filterable placeholder="请选择">
            <Option v-for="(item, i) in orgUserList" :key="i" :value="item.id" :label="item.name">
              <i class="dian" :class="{ 'red': item.workingState == 0, 'orange': item.isSus == 1 }"></i>
              {{ item.staffNo ? item.name + '-' + item.staffNo : item.name }}
            </Option>
          </Select>
        </div>
        <div class="btn-item">
          <Button type="primary" @click="reset()">查询</Button>
        </div>
      </div>
      <div class="table-box tableBox">
        <loading :isShow="listLoading" />
        <Form :model="formData" ref="formDynamic">
          <Table
            :columns="columns"
            :data="formData.tableData"
            @on-select-all-cancel="handleCancelSelectAll"
            @on-select-all="handleSelectAll"
            @on-select="handleSelect"
            @on-select-cancel="handleCancel"
            max-height="500"
            ref="selection"
          >
            <template slot-scope="{ row, index }" slot="serviceAgent">
              <FormItem :prop="'tableData.' + index + '.serviceAgent'" :rules="{ required: true, message: '请选择产品', trigger: 'change' }">
                <Select
                  v-model="formData.tableData[index].serviceAgent"
                  @on-change="val => selServiceAgent(val, index)"
                  transfer
                  clearable
                  filterable
                  placeholder="请选择"
                >
                  <Option v-for="(item, i) in orgUserList" :key="i" :value="item.id" :label="item.name">
                    <i class="dian" :class="{ 'red': item.workingState == 0, 'orange': item.isSus == 1 }"></i>
                    {{ item.staffNo ? item.name + '-' + item.staffNo : item.name }}
                  </Option>
                </Select>
              </FormItem>
            </template>
          </Table>
        </Form>
        <Page
          :total="total"
          :current.sync="searchParams.pageNo"
          :page-size="searchParams.pageSize"
          show-total
          @on-change="getList"
          style="text-align: center; margin-top: 20px"
        />
        <div style="margin-top: 10px">
          <Checkbox v-model="isAll" @on-change="changeIsAll">全选</Checkbox>
          <span>已选{{ selIds.length }}/{{ total }}项</span>
        </div>
        <div style="margin-top: 10px">
          <Button type="primary" @click="setAllServiceAgent">选择服务代理人</Button>
        </div>
      </div>
      <div class="ivu-modal-footer">
        <Button type="text" @click="visible = false">取消</Button>
        <Button type="primary" @click="save" :loading="loading">确认</Button>
      </div>
    </Modal>
    <serviceAgentModal ref="serviceAgentModal" @success="selAllServiceAgent"></serviceAgentModal>
  </div>
</template>

<script>
import _ from 'lodash';
import { pageTool, common } from '@/api/mixins';
import serviceAgentModal from './serviceAgentModal';
export default {
  components: { serviceAgentModal },
  props: {},
  mixins: [pageTool, common],
  data() {
    return {
      isAll: false,
      visible: false,
      loading: false,
      formData: {
        tableData: []
      },
      searchAllList: [],
      searchParams: {
        pageNo: 1,
        pageSize: 10
      },
      columns: [
        {
          type: 'selection',
          width: 50,
          align: 'center'
        },
        {
          title: '保单号',
          align: 'center',
          key: 'policyNo'
        },
        {
          title: '保险公司',
          align: 'center',
          key: 'companyName'
        },
        {
          title: '出单人',
          align: 'center',
          key: 'salesmanName'
        },
        {
          title: '现服务代理人',
          align: 'center',
          key: 'serviceAgentName',
          render(h, params) {
            return (
              <span>
                {params.row.serviceAgentStaffNo}/{params.row.serviceAgentName}
              </span>
            );
          }
        },
        {
          title: '服务代理人',
          align: 'center',
          slot: 'serviceAgent'
        }
      ],
      companyList: [],
      orgUserList: [],
      selIds: [],
      detail: {},
      policyAllotRecords: [] //回显列表
    };
  },

  methods: {
    // 机构内部业务员
    getOrgUserList() {
      this.$http({
        url: '/buz/userBase/queryUserByEntryConfig',
        type: 'get',
        data: {
          orgId: this.detail.organizationId
          // workingState: '1',
          // isSus: '0'
        }
      }).then(res => {
        this.orgUserList = res.data;
      });
    },
    /**
     * 批量设置服务代理人
     */
    setAllServiceAgent() {
      if (this.selIds.length == 0) {
        return this.$notice.error('您还没有选择要分配的保单');
      }
      this.$refs.serviceAgentModal.open(this.detail);
    },
    selAllServiceAgent(id) {
      let ids = this.selIds.map(i => i.id);
      this.selIds = [];
      this.isAll = false;
      console.log('ids------', ids);
      this.tableData.forEach((item, index) => {
        if (ids.includes(item.id)) {
          this.$set(this.tableData[index], 'serviceAgent', id);
        }
      });
      this.formData.tableData.forEach((item, index) => {
        if (ids.includes(item.id)) {
          this.$set(this.formData.tableData[index], '_checked', false);
          this.$set(this.formData.tableData[index], 'serviceAgent', id);
        }
      });
    },
    /**
     * 选择服务代理人
     * val 代理人id
     * index 表格索引
     */
    selServiceAgent(val, index) {
      let ids = this.selIds.map(i => i.id);
      console.log('selIds------', this.formData.tableData[0]);

      this.formData.tableData.forEach((item, idx) => {
        if (ids.includes(item.id) && index != idx) {
          this.$set(this.formData.tableData[idx], '_checked', true);
          // this.$set(this.formData.tableData[idx], 'serviceAgent', id);
        }
      });
      this.selIds = this.selIds.filter(i => i.id != this.formData.tableData[index].id);
      let idx = this.tableData.findIndex(i => i.id == this.formData.tableData[index].id);
      this.$set(this.tableData[idx], 'serviceAgent', val);

      // this.tableData.find(i => i.id == this.formData.tableData[index].id).serviceAgent = val;
    },
    changeIsAll(val) {
      this.$refs.selection.selectAll(val);
      console.log(this.searchAllList);
      if (this.tableData.length == this.total) {
        this.selIds = val ? JSON.parse(JSON.stringify(this.tableData)) : [];
      } else {
        this.selIds = val ? JSON.parse(JSON.stringify(this.searchAllList)) : [];
      }
    },
    // 取消全选
    handleCancelSelectAll(selection) {
      //从已选项中移除当页数据
      console.log('取消全选');
      this.selIds = _.differenceBy(this.selIds, this.tableData, 'id');
    },
    // 全选
    handleSelectAll(selection) {
      //数组合并，有可能用户先选择了某几项，已经被我们push进去，因此数组合并需要去重一下
      console.log('全选');
      this.selIds = _.uniqBy(this.selIds.concat(selection), 'id');
    },
    //选中单项
    handleSelect(selection, row) {
      //添加到已选项
      console.log('选中单项');
      this.selIds.push(row);
    },
    //取消选中单项
    handleCancel(selection, row) {
      console.log('取消选中单项');
      //从已选项中去除取消项
      this.selIds = this.selIds.filter(item => {
        return item.id != row.id;
      });
      _.remove(this.selIds, n => {
        return n.id === row.id;
      });
    },
    save() {
      this.$refs.formDynamic.validate(valid => {
        let selItems = this.tableData.filter(i => i.serviceAgent);
        console.log('selItems--------', selItems);
        if (this.total == 0) {
          return this.$notice.error('没有可分配的孤儿单');
        }
        if (valid && selItems.length == this.total) {
          //判断是否已经选择服务代理人
          this.visible = false;
          let policyAllotRecords = selItems.map(item => {
            return {
              policyId: item.id,
              policyNo: item.policyNo,
              serviceAgent: item.serviceAgent
            };
          });
          this.$emit('success', policyAllotRecords);
        } else {
          this.$notice.error('您还有孤儿单未分配，请核对');
        }
      });
    },
    // 查询签约保司
    queryInsuranceCompanyList() {
      this.$http({
        url: '/buz/insuranceCompany/read/list',
        type: 'POST',
        data: {
          companyType: '1'
        }
      }).then(res => {
        this.companyList = res.data;
      });
    },
    reset() {
      this.searchParams.pageNo = 1;
      this.getList();
      this.getAllList();
    },
    getList(isFrist = false) {
      console.log(this.searchParams);
      this.listLoading = true;
      this.$http({
        url: '/buz/policy/listSalesmanPolicys',
        type: 'POST',
        data: this.searchParams
      })
        .then(res => {
          this.$refs.formDynamic && this.$refs.formDynamic.resetFields();
          this.listLoading = false;
          if (isFrist === true) {
            if (this.policyAllotRecords) {
              res.data.forEach((item, index) => {
                if (this.policyAllotRecords.find(i => i.policyId == item.id)) {
                  this.$set(res.data[index], 'serviceAgent', this.policyAllotRecords.find(i => i.policyId == item.id).serviceAgent);
                }
              });
            }
          } else {
            let selItems = this.tableData.filter(i => i.serviceAgent);
            if (selItems.length) {
              res.data.forEach((item, index) => {
                if (selItems.find(i => i.id == item.id)) {
                  this.$set(res.data[index], 'serviceAgent', selItems.find(i => i.id == item.id).serviceAgent);
                }
                console.log('this.selIds', this.selIds);
                if (this.selIds.find(i => i.id == item.id)) {
                  this.$set(res.data[index], '_checked', true);
                }
              });
            }
            if (this.selIds.length) {
              res.data.forEach((item, index) => {
                if (this.selIds.find(i => i.id == item.id)) {
                  this.$set(res.data[index], '_checked', true);
                }
              });
            }
          }
          this.formData.tableData = res.data;
          this.total = res.total;
        })
        .catch(() => {
          this.listLoading = false;
        });
    },

    getAllList(isFrist) {
      let params = {
        pageNo: 1,
        pageSize: 999,
        serviceAgent: this.searchParams.serviceAgent
      };
      if(!isFrist){
        params = {...this.searchParams,...params}
      }
      this.$http({
        url: '/buz/policy/listSalesmanPolicys',
        type: 'POST',
        data:params
      }).then(res => {
        console.log('res----', res);
        // this.total = res.total;
        if (isFrist) {
          if (this.policyAllotRecords) {
            res.data.forEach((item, index) => {
              if (this.policyAllotRecords.find(i => i.policyId == item.id)) {
                this.$set(res.data[index], 'serviceAgent', this.policyAllotRecords.find(i => i.policyId == item.id).serviceAgent);
              }
            });
          }
          this.tableData = res.data;
        } else {
          this.searchAllList = res.data;
        }
      });
    },
    open(data, policyAllotRecords = []) {
      this.searchParams = {
        pageNo: 1,
        pageSize: 10
      };
      this.formData = {
        tableData: []
      };
      this.selIds = [];
      this.isAll = false;
      this.policyAllotRecords = policyAllotRecords;
      data = JSON.parse(JSON.stringify(data));
      this.queryInsuranceCompanyList();
      this.getOrgUserList();
      this.detail = data;
      this.visible = true;
      this.$refs.formDynamic && this.$refs.formDynamic.resetFields();
      this.searchParams.serviceAgent = data.id;
      this.getList(true);
      this.getAllList(true);
    }
  }
};
</script>
<style lang="scss" scoped>
.input-item {
  .ivu-select {
    flex: 1 !important;
  }
}

.dian {
  display: inline-block;
  width: 5px;
  height: 5px;
  background: #35bf3f;
  border-radius: 50%;
  margin-right: 4px;
  vertical-align: top;
  transform: translateY(7px);

  &.red {
    background: #e3461f;
  }
}

.table-box {
  .ivu-form-item {
    margin-bottom: 0;
  }
}

/deep/.ivu-modal-body {
  padding-right: 10px !important;
  padding-left: 10px !important;
}
</style>
